import React, { useEffect, useRef } from 'react';
import './webstoreOrderDetailsModal.scss';

const WebstoreOrderDetailsModal = ({ order, onClose }) => {
  const modalRef = useRef();

  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  // Close on outside click
  const handleClickOutside = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose();
    }
  };

  return (
    <div className="order-modal-overlay" onClick={handleClickOutside}>
      <div className="order-modal-content" ref={modalRef}>
        <button className="modal-close" onClick={onClose}>×</button>

        <h2>Order Details</h2>
        <p><strong>Order ID:</strong> {order._id}</p>
        <p><strong>Created:</strong> {new Date(order.createdAt).toLocaleString()}</p>
        <p><strong>Status:</strong> {order.status}</p>
        <p><strong>Payment Method:</strong> {order.paymentMethod || 'N/A'}</p>
        <p><strong>Note:</strong> {order.note || '—'}</p>

        <h3>User Info</h3>
        <p><strong>Username:</strong> {order.user?.username}</p>
        <p><strong>Full Name:</strong> {order.user?.name || '—'}</p>
        <p><strong>Email:</strong> {order.user?.email}</p>
        <p><strong>Contact Number:</strong> {order.user?.contactNumber || '—'}</p>
        <p><strong>Address:</strong> {order.user?.address || '—'}</p>

        <h3>Items</h3>
        <div className="scrollable-table">
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Category</th>
                <th>Delivery Time</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {order.items.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.title}</td>
                  <td>{item.category}</td>
                  <td>{item.deliveryTime || 3} day(s)</td>
                  <td>₱{item.price.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="modal-total"><strong>Total:</strong> ₱{order.total.toFixed(2)}</p>
      </div>
    </div>
  );
};

export default WebstoreOrderDetailsModal;
